"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstanceIds = exports.getInstance = void 0;
var environments_1 = require("../configs/environments");
var instances_1 = require("../configs/instances");
var instances_2 = require("../types/instances");
var environment_1 = require("./environment");
/**
 * Get a configured instance definition by the given id.
 */
// eslint-disable-next-line complexity
var getInstance = function (id, environment) {
    var _a;
    if (environment === void 0) { environment = environments_1.Environment.PROD; }
    var instance = instances_1.instances[id];
    if (!instance || !(0, environment_1.getEnvironments)().includes(environment)) {
        return undefined;
    }
    if (!instance.apiBaseUrl[environment]) {
        throw new Error("Missing apiBaseUrl for environment ".concat(environment, " on instance ").concat(id));
    }
    if (!instance.hostname[environment]) {
        throw new Error("Missing hostname for environment ".concat(environment, " on instance ").concat(id));
    }
    if (!instance.moodleBaseUrl[environment]) {
        throw new Error("Missing moodleBaseUrl for environment ".concat(environment, " on instance ").concat(id));
    }
    if (instance.auth0 && !instance.auth0[environment]) {
        throw new Error("Missing auth0 configuration for environment ".concat(environment, " on instance ").concat(id));
    }
    return __assign(__assign({}, instance), { environment: environment, id: id, apiBaseUrl: instance.apiBaseUrl[environment], hostname: instance.hostname[environment], aws: instance.deployment === instances_2.MondrianDeploymentType.AMPLIFY
            ? instance.aws[environment]
            : undefined, moodleBaseUrl: instance.moodleBaseUrl[environment], auth0: (_a = instance.auth0) === null || _a === void 0 ? void 0 : _a[environment] });
};
exports.getInstance = getInstance;
/**
 * Get all configured instance names.
 */
var getInstanceIds = function () {
    return Object.keys(instances_1.instances);
};
exports.getInstanceIds = getInstanceIds;
